const RouterConfig = [
    // 首页
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        title: '首页'
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        title: '首页'
    },
    // 产品介绍
    {
        path: '/product',
        name: 'Products',
        component: () => import('../views/Products.vue'),
        title: '产品介绍'
    },
    // 解决方案
    {
        path: '/programme',
        name: 'Programme',
        component: () => import('../views/Programme.vue'),
        title: '解决方案'
    },
    // 合作伙伴
    {
        path: '/partner',
        name: 'Partner',
        component: () => import('../views/Partner.vue'),
        title: '合作伙伴'
    },
    // 版本
    {
        path: '/edition',
        name: 'Edition',
        component: () => import('../views/Edition.vue'),
        title: '版本'
    },
    // {
    //     path: '/login',
    //     name: 'Login',
    //     component: () => import('../views/Login.vue'),
    //     title: '版本'
    // },
    {
        path: '/media',
        name: 'Media',
        component: () => import('../views/foot/Media.vue'),
        title: '媒体',
        ishide: true
    },
    {
        path: '/mediaDetail',
        name: 'MediaDetail',
        component: () => import('../views/foot/MediaDetail.vue'),
        title: '媒体详情',
        ishide: true
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/foot/Contact.vue'),
        title: '联系我们'
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('../views/foot/Terms.vue'),
        title: '服务条款'
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('../views/foot/Help.vue'),
        title: '帮助中心'
    },
    {
        path: '/video',
        name: 'Video',
        component: () => import('../views/foot/Video.vue'),
        title: '帮助中心'
    },
    {
        path: '/class',
        name: 'Class',
        component: () => import('../views/lesson/class/Class.vue'),
        title: '班级'
    },
    {
        path: '/addClass',
        name: 'AddClass',
        component: () => import('../views/lesson/class/AddClass.vue'),
        title: '添加班级'
    },
    {
        path: '/classStudent',
        name: 'ClassStudent',
        component: () => import('../views/lesson/class/ClassStudent.vue'),
        title: '学生列表'
    },
    {
        path: '/endClass',
        name: 'EndClass',
        component: () => import('../views/lesson/class/EndClass.vue'),
        title: '添加班级'
    },
    {
        path: '/addHomework',
        name: 'AddHomework',
        component: () => import('../views/lesson/class/AddHomework.vue'),
        title: '布置作业'
    },
    {
        path: '/homework',
        name: 'Homework',
        component: () => import('../views/lesson/homework/Homework.vue'),
        title: '作业'
    },
    {
        path: '/classHomework',
        name: 'ClassHomework',
        component: () => import('../views/lesson/homework/ClassHomework.vue'),
        title: '班级作业'
    },
    {
        path: '/historyHomework',
        name: 'HistoryHomework',
        component: () => import('../views/lesson/homework/HistoryHomework.vue'),
        title: '历史作业'
    },
    {
        path: '/correctHomework',
        name: 'CorrectHomework',
        component: () => import('../views/lesson/homework/CorrectHomework.vue'),
        title: '批改作业'
    },
    {
        path: '/myPlan',
        name: 'MyPlan',
        component: () => import('../views/lesson/plan/MyPlan.vue'),
        title: '我的教材'
    },
    {
        path: '/addPlan',
        name: 'AddPlan',
        component: () => import('../views/lesson/plan/AddPlan.vue'),
        title: '创建教材'
    },
    {
        path: '/coursewareList',
        name: 'CoursewareList',
        component: () => import('../views/lesson/plan/CoursewareList.vue'),
        title: '课件列表'
    },
    {
        path: '/addCoursewareList',
        name: 'AddCoursewareList',
        component: () => import('../views/lesson/plan/AddCoursewareList.vue'),
        title: '添加课件'
    },
    {
        path: '/preparation',
        name: 'Preparation',
        component: () => import('../views/lesson/plan/Preparation.vue'),
        title: '课件列表'
    },
    {
        path: '/sharePlan',
        name: 'SharePlan',
        component: () => import('../views/lesson/SharePlan.vue'),
        title: '共享教材'
    },
    {
        path: '/courseware',
        name: 'Courseware',
        component: () => import('../views/lesson/courseware/Courseware.vue'),
        title: '课件中心'
    },
    {
        path: '/resource',
        name: 'Resource',
        component: () => import('../views/lesson/resource/Resource.vue'),
        title: '资源中心'
    },
    {
        path: '/setting',
        name: 'Setting',
        component: () => import('../views/lesson/Setting.vue'),
        title: '个人设置'
    },
    {
        path: '/classView',
        name: 'ClassView',
        component: () => import('../views/lesson/ClassView.vue'),
        title: '详情'
    },
];

// 深复制一个配置用于传递修改；
let [...dynamicRouterConfig] = RouterConfig;

export default dynamicRouterConfig;



// WEBPACK FOOTER //
// ./src/router/dynamic-router-config.js